import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { CloseButton, Text } from '@/shared/ui';
import { BackButton } from './BackButton';

type Props = {
  title?: string;
  onBack?: () => void;
  backAriaLabel?: string;
  additionalMenuItems?: ReactNode;
  onClose: () => void;
};

export const SideMenuHeader = ({
  title,
  additionalMenuItems,
  onClose,
  onBack,
  backAriaLabel,
}: Props) => {
  const { t } = useTranslation();
  return (
    // heightはPageHeaderのbottomBorderに合わせるため49pxにしている
    // z-10: スクロール時に後続のパネル内容がヘッダー上に描画されるのを防ぐ
    <div className="sticky top-0 z-10 flex h-[49px] shrink-0 items-center justify-between border-b bg-white px-4">
      <div className="flex items-center gap-2">
        {onBack && <BackButton onBack={onBack} ariaLabel={backAriaLabel} />}
        {title && (
          <Text variant="subhead" as="h2">
            {title}
          </Text>
        )}
      </div>
      <div className="flex items-center justify-center gap-2">
        {additionalMenuItems && additionalMenuItems}
        <CloseButton onClick={onClose} aria-label={t('ai.common.close-panel')} />
      </div>
    </div>
  );
};
